import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { useIsMobile } from 'hooks/useIsMobile'
import { ILearningPathCard } from 'models/learningPathCard.model'
import {
  LearningPathCardBase,
  StackedImages,
  Tag,
  Header,
  ProgressBar,
} from '../../atoms'
import styles from './LearningPathCard.module.scss'

interface Props {
  learningPath: ILearningPathCard
  className?: string
  style?: React.CSSProperties
}

export const LearningPathCard = ({ learningPath, className, style }: Props) => {
  const isMobile = useIsMobile()
  const history = useHistory()

  const { t } = useTranslation()

  const openLearningPath = () => {
    history.push(`/learning-path/${learningPath.id}`)
  }

  const enrol = learningPath.enrol
  return (
    <LearningPathCardBase
      className={className}
      style={style}
      onClick={() => openLearningPath()}
    >
      <div
        className={classNames(
          styles.container,
          isMobile ? styles.containerMobile : ''
        )}
      >
        <StackedImages
          src={learningPath.pictureUrl}
          className={isMobile ? styles.imagesMobile : ''}
        />
        <div className={styles.infoContainer}>
          <div>
            <Tag
              text={t('learningPaths.cards.tags.default')}
              icon={faGraduationCap}
            />
            {learningPath.optional && (
              <Tag text={t('learningPaths.cards.tags.optional')} />
            )}
          </div>
          <Header
            title={learningPath.name}
            description={learningPath.description}
          />
          {!learningPath.optional && (
            <ProgressBar
              counters={{
                total: learningPath.requiredCoursesCount,
                completed: learningPath.completedRequiredCourses,
              }}
              progressPercentage={Number(enrol?.overallProgress || 0)}
              advance={enrol?.status}
            />
          )}
        </div>
      </div>
    </LearningPathCardBase>
  )
}
